import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SocketProvider } from './context/SocketContext';
import './i18n'; // Initialize i18n
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import InvoiceTemplates from './pages/InvoiceTemplates';
import InvoiceTemplateForm from './pages/InvoiceTemplateForm';
import Settings from './pages/Settings';
import UserManagement from './pages/UserManagement';
import Messages from './pages/Messages';

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
    >
      <ThemeProvider>
        <AuthProvider>
          <SocketProvider>
            <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <Dashboard />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <Invoices />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoice-templates"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <InvoiceTemplates />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoice-templates/new"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <InvoiceTemplateForm />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoice-templates/edit/:id"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <InvoiceTemplateForm />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />


          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <Settings />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/users"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <UserManagement />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/messages"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Navbar />
                  <Messages />
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      </SocketProvider>
    </AuthProvider>
    </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
